<template>
  <div id="app">
    <header>
      <el-row :gutter="0">
        <el-col :span="8">
          &nbsp;
        </el-col>
        <el-col :span="8">
          <img alt="Huggy" src="./assets/logo.svg">
        </el-col>
        <el-col :span="8">
          <el-select v-model="locale" style="float: right; width: 80px;" size="mini">
            <el-option label="PT" value="pt">PT</el-option>
            <el-option label="EN" value="en">EN</el-option>
            <el-option label="ES" value="es">ES</el-option>
          </el-select>
        </el-col>
      </el-row>
    </header>

    <router-view/>
  </div>
</template>

<style lang="scss">
#app {
  font-family: 'Rubik', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: left;
  color: #34474C;

  header{
    margin: 0 auto;
    max-width: 720px;
    padding: 32px;
    text-align: center;
  }
}

</style>

<script>
  export default {
    name: 'App',
    data: function () {
      return {
        locale: 'pt',
      }
    },
    created: function () {
      let token = this.$route.query.token

      if(token.length > 0){
        this.$store.commit('setToken', token)
      } else {
        this.$router.push('/error?code=invalid_token')
      }

      if(typeof this.$route.query.locale !== "undefined"){
        this.locale = this.$route.query.locale
      }
    },
    watch: {
      locale: function (value) {
        this.$i18n.locale = value
      }
    }
  }
</script>